import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { createApiUrl, getToken } from '../../../util';
import axios, { AxiosError } from 'axios';
import { appToast } from 'components/Basic/CustomToast';
import api from 'api/axiosInstance';

type UpdateGutterLinePayload = {
  newGutterLines: Array<{ coords: number[][]; roofSegmentId: string }>;
  removedGutterLineIds: number[];
};

async function updateGutterLinesAPI(
	payload: UpdateGutterLinePayload, 
	uuid: string,
	designType: 'ROOF'| 'SOLAR'
) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};
	const body = {
		...payload,
		uuid,
	};
	const endpoint = designType === 'ROOF' ? '/designs/roof/edit-gutter-lines' :
		'/designs/edit-gutter-lines';
	const { data } = await api.post(createApiUrl(endpoint), body, config);
	return data;
}

export default function useMutateGutterLines() {
	const { uuid: designUUID, designType } = useSelector((state: RootState) => state.roofData.data);
	const { selectedFacets } = useSelector((state: RootState) => state.roofToolLines.data);

	const payload : UpdateGutterLinePayload = {
		newGutterLines: [],
		removedGutterLineIds: [],
	};

	for (const [roofSegmentId, { removedGutterLineIds, newAddedGutterLines }] of Object.entries(selectedFacets)) {
		if (newAddedGutterLines?.length) {
			payload.newGutterLines.push(
				...newAddedGutterLines.filter(eachLine => eachLine.discard === false).map((gl) => ({
					roofSegmentId,
					coords: gl.coords,
				}))
			);
		}

		if (removedGutterLineIds.length) {
			payload.removedGutterLineIds.push(...removedGutterLineIds);
		}
	}

	return useMutation(
		'edit-gutter-lines',
		() => {
			if(payload.newGutterLines.length || payload.removedGutterLineIds.length) {
				return updateGutterLinesAPI(payload, designUUID, designType);
			}
			return Promise.resolve(null);
		},
		{
			onError: (e: AxiosError) => {
				appToast.error(e.message || 'Something went wrong while updating Gutter lines Edits.');
			},
		}
	);
}